<template>
<!-- 会员管理－单个会员积分详情 -->
    <content-view>
        <div class="wrap-container-in">
            <a-table bordered :dataSource="dataSource" :loading="loading" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.id">
                <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                <span slot="financeType" slot-scope="a,row">{{row.financeType == '1' ? '加积分' : '减积分'}}</span>
                <span slot="changePoint" slot-scope="a,row">{{row.changePoint ? (row.financeType == '1' ? '+' : '-') : ""}}{{row.changePoint}}</span>
            </a-table>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    const columns = [
    {
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
    },
    {
        title: "获取/消耗积分",
        dataIndex: "changePoint",
        scopedSlots: { customRender: "changePoint" }
    },
    {
        title: "类型",
        dataIndex: "financeType",
        scopedSlots: { customRender: "financeType" }
    },
    {
        title: "来源",
        dataIndex: "sourceName"
    },
    {
        title: "变更时间",
        dataIndex: "businessTime"
    },
    ]
    export default {
        name: "storeDetail",
        components: {},
        props: {},
        data() {
            return {
                loading: false,
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
            };
        },
        computed: {},
        methods: {
            changePage(page) {
                this.pagination = page;
                this.getList();
            },
            // 获取会员积分详情
            getList() {
                this.loading = true;
                this.$api.member.recordList({
                    body: {
                        userId: this.id,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    }
                }).then(res => {
                    this.loading = false;
                    this.dataSource = res.list;
                    this.pagination.total = res.total;
                }).catch(err => {
                    this.loading = false;
                })
            },
        },
        created() {},
        mounted() {
            this.id = this.$route.query.id
            this.getList()
        }
    };
</script>
<style lang="scss">
</style>